import { render, staticRenderFns } from "./indexTournament.vue?vue&type=template&id=19ef461f&scoped=true&"
import script from "./indexTournament.vue?vue&type=script&lang=js&"
export * from "./indexTournament.vue?vue&type=script&lang=js&"
import style0 from "./indexTournament.vue?vue&type=style&index=0&id=19ef461f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef461f",
  null
  
)

export default component.exports